import { render } from "./PageFormulirKendaraan.vue?vue&type=template&id=3442fb36"
import script from "./PageFormulirKendaraan.vue?vue&type=script&lang=js"
export * from "./PageFormulirKendaraan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__